import { useState } from 'react';
import { channelNav, quickChannels } from '@/mocks/home';

interface SiteHeaderProps {
  notify: (msg: string) => void;
}

export default function SiteHeader({ notify }: SiteHeaderProps) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');

  const handleSearch = () => {
    const keyword = query.trim();
    notify(keyword ? `正在搜索「${keyword}」相关内容` : '请输入想找的资源关键词');
  };

  return (
    <header className="sticky top-0 z-50 border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-xl"></i>
            </span>
            <div className="leading-tight">
              <h1 className="font-heading text-xl font-black tracking-tight text-foreground-950">爆瓜福利</h1>
              <p className="hidden text-[11px] text-foreground-500 sm:block">资源包 · 网盘文件 · 素材合集</p>
            </div>
          </div>

          <div className="hidden flex-1 items-center justify-end gap-2 md:flex lg:pl-10">
            <div className="flex h-10 w-full max-w-sm items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 focus-within:border-primary-400">
              <span className="flex h-4 w-4 items-center justify-center text-foreground-400">
                <i className="ri-search-line text-base"></i>
              </span>
              <input
                type="text"
                value={query}
                onChange={(event) => setQuery(event.target.value)}
                onKeyDown={(event) => { if (event.key === 'Enter') handleSearch(); }}
                placeholder="搜索资源包 / 网盘文件 / 素材合集"
                className="h-full w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
              />
              <button
                type="button"
                onClick={handleSearch}
                className="cursor-pointer whitespace-nowrap rounded-sm bg-primary-500 px-3 py-1.5 text-xs font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                搜索
              </button>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => notify('登录功能为演示展示，暂未开放')}
              className="hidden cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-3.5 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 sm:block"
            >
              登录
            </button>
            <button
              type="button"
              onClick={() => notify('已为你打开爆瓜福利下载入口')}
              className="hidden cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:block"
            >
              免费下载
            </button>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setOpen((prev) => !prev)}
              className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
            >
              <i className={open ? 'ri-close-line text-xl' : 'ri-menu-2-line text-xl'}></i>
            </button>
          </div>
        </div>
      </div>

      <div className="hidden border-t border-background-200 bg-background-100 lg:block">
        <div className="flex w-full items-center gap-1 overflow-x-auto px-4 md:px-8 hide-scrollbar">
          {channelNav.map((item) => (
            <button
              key={item.label}
              type="button"
              onClick={() => notify(`已切换至「${item.label}」频道`)}
              className={`flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-t-md border-b-2 px-3.5 py-2.5 text-sm transition-colors ${
                item.active
                  ? 'border-primary-500 bg-background-50 font-medium text-primary-700'
                  : 'border-transparent text-foreground-600 hover:border-primary-200 hover:text-foreground-900'
              }`}
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className={item.icon}></i>
              </span>
              {item.label}
            </button>
          ))}
        </div>
      </div>

      {open ? (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 lg:hidden">
          <div className="flex h-10 items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3">
            <span className="flex h-4 w-4 items-center justify-center text-foreground-400">
              <i className="ri-search-line text-base"></i>
            </span>
            <input
              type="text"
              value={query}
              onChange={(event) => setQuery(event.target.value)}
              placeholder="搜索资源包 / 网盘文件 / 素材合集"
              className="h-full w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
            />
            <button type="button" onClick={handleSearch} className="cursor-pointer text-sm font-medium text-primary-600">搜索</button>
          </div>
          <div className="mt-4 grid grid-cols-3 gap-2">
            {quickChannels.map((channel) => (
              <button
                key={channel.label}
                type="button"
                onClick={() => { setOpen(false); notify(`已进入「${channel.label}」`); }}
                className="flex cursor-pointer flex-col items-center gap-2 rounded-lg border border-background-200 bg-background-100 py-3 text-xs text-foreground-700"
              >
                <span className={`flex h-9 w-9 items-center justify-center rounded-md ${channel.color}`}>
                  <i className={`${channel.icon} text-lg`}></i>
                </span>
                {channel.label}
              </button>
            ))}
          </div>
          <div className="mt-4 grid grid-cols-2 gap-2">
            {channelNav.map((item) => (
              <button
                key={item.label}
                type="button"
                onClick={() => { setOpen(false); notify(`已切换至「${item.label}」频道`); }}
                className={`cursor-pointer whitespace-nowrap rounded-md border px-3 py-2 text-sm ${
                  item.active
                    ? 'border-primary-300 bg-primary-100 text-primary-700'
                    : 'border-background-200 text-foreground-700'
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      ) : null}
    </header>
  );
}